// File: frontend/src/components/utility/SEO.js

import React from 'react';

const SEO = ({
  title,
  description,
  canonical,
  image,
  type = 'website',
  noindex = false,
}) => {
  const baseUrl = process.env.REACT_APP_APP_URL || 'https://allegoryinsurance.com';
  const defaultImage = `${baseUrl}/images/og-default.png`;
  
  const fullTitle = title 
    ? `${title} | Allegory Insurance` 
    : 'Allegory Insurance - Digital Insurance Wallet';
  
  const fullDescription = description || 
    'Your Smart Digital Insurance Wallet. Manage all your insurance policies in one secure place.';
  
  const fullImage = image || defaultImage;
  const fullCanonical = canonical || baseUrl;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:site_name" content="Allegory Insurance" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
    </>
  );
};

export default SEO;